module.exports = __webpack_public_path__ + "static/media/logo-snow-bridg_new.76f21642.png";